import "./processamento.css";

export default function ProcessandoModal({ open, message }) {
  if (!open) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <div className="spinner"></div>
        <p>{message || "Processando..."}</p>
      </div>
    </div>
  );
}
